module.exports = __webpack_public_path__ + "img/studentenwohnheimvallendar_1.770d70a2.jpg";